import { addMonths, endOfToday, isBefore, isFuture, isToday } from "date-fns";

export const futureButNoMoreThan9Months = (value: Date) => {
  return (
    (isFuture(value) || isToday(value)) &&
    isBefore(value, addMonths(endOfToday(), 9))
  );
};
